import React from 'react'
import { TextandLink } from '../styles/index'

const HyperLink = ({ content }) => {
    let link = content.content.map((el, index) => {
        if (el.nodeType === "hyperlink") {
            return <a href={`${el.data.uri}`} target="_blank">{el.content[0].value}</a>
        } else {
            let splitText = el.value.split('\n');
            let newSplit = splitText.map((split, index) => {
                if (split !== "") { return <span>{split}</span> }
                else {
                    return null
                }
            })
            return newSplit
        }
    });
    return <TextandLink className="text-with-link">{link}</TextandLink>;
}

export default HyperLink;